import React, {useState} from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import {makeInput} from '../util/Forms.js';

import {produce} from 'immer';

import TeamEditor from './TeamEditor.js';
import {fields, personFields} from './Client.js';
import useSubmitCancel from "../util/useSubmitCancel";


/*
Renders a form for creating or editing a Client
 */
let ClientCreator = ({
	client,
	cancel,
	execute,
}) => {
	const [tempClient, setTempClient] = useState({...client});
	const update = recipe => setTempClient(produce(tempClient, recipe));


	// enter- and escape-handling; allow the teameditor to prevent the handling of enter and escape
	const [submitRef, cancelRef, onKey, teamEditorSubmitCancel] = useSubmitCancel();


	// inputs

	const type = tempClient.type ? tempClient.type :
		tempClient.team ? 'team' :
			'person';

	const onChangeClient = ev => {
		ev.preventDefault();

		const {name, value} = ev.target;

		update(draft => {
			draft[name] = value;
			// use the same name and surname for the person
			if (draft.person && (name === 'name' || name === 'surname'))
				draft.person[name] = value;
		});
	};

	const onChangePerson = ev => {
		ev.preventDefault();

		const {name, value} = ev.target;

		update(draft => {
			draft.person[name] = value;
			draft.type = 'person';
		});
	}

	let orderedFields = [
		'Vorname',
		'Nachname',
	];
	if (type === 'person')
		orderedFields = orderedFields.concat([
			'Geschlecht',
			'Geb.',
		]);
	orderedFields = orderedFields.concat([
		'E-Mail-Adresse',
		'Telefon',
		'Straße',
		'Hausnummer',
		'PLZ',
		'Ort',
	]);
	if (type === 'person')
		orderedFields = orderedFields.concat([
			'Geburtsort',
			'Vater',
			'Mutter',
			'Geschwister',
			'Partner',
			'Firma',
			'Funktion',
			'Vita',
		]);
	orderedFields.push('Notiz');

	const inputs = orderedFields.map(l => {
		// default fields edit the client
		// person fields edit the person
		const field = fields.find(f => f.label === l);
		return field ? makeInput(field, tempClient, onChangeClient) :
			makeInput(personFields.find(f => f.label === l), tempClient, onChangePerson);
	});

	// team-editor

	const updateTeam = team => update(draft => {
		draft.team = team;
    	draft.type = 'team';
	});

	const teamEditor = (<Form.Group>
		<TeamEditor
			team = {tempClient.team}
			updateTeam = {updateTeam}
			handleKeyEventIf = {teamEditorSubmitCancel}/>
	</Form.Group>);


	// if creating: client type is switchable

	const handleTypeChange = ev => {
		const type = ev.target.id;
		console.log(`selected type ${type}`);

		update(draft => {
			draft.type = type;
			if (type === 'person' && !draft.person)
				draft.person = { };
			else
				if (type === 'team' && !draft.team)
					draft.team = {
						name: '',
						members: [],
					};
		});
	};

	const clientTypeToggle = (
		<>
			<div>
				<Form.Check
					inline
					label = 'Person'
					type = 'radio'
					id = 'person'
					name = 'clientTypeSwitch'
					checked = {type === 'person'}
					onChange = {handleTypeChange}/>
				<Form.Check
					inline
					label = 'Team'
					type = 'radio'
					id = 'team'
					name = 'clientTypeSwitch'
					checked = {type === 'team'}
					onChange = {handleTypeChange}/>
			</div>
		</>
	);


	// on submit: validate and execute

	const onSubmit = ev => {
		const form = ev.currentTarget.form;
		ev.preventDefault();

		const valid = form.checkValidity();
		if (!valid)
            ev.stopPropagation();
		else {
			// keep only team or person
			execute(produce(tempClient, draft => {
				// when adding remove the cached person/team part and type marker
				if (draft.type) {
					delete draft[draft.type === 'person' ? 'team' : 'person'];
					delete draft.type;
				}
			}));
		}
	};

	const onCancel = ev => {
		ev.preventDefault();
		cancel();
	};


	// render

	return (
		<>
			<Row>
				<Col>
					<Form
						onKeyUp = {onKey}
						noValidate
						validated = {true}
						onSubmit = {ev => ev.preventDefault()}>
						<Form.Group>
							{inputs}
						</Form.Group>
						{!tempClient.id &&
						<Form.Group>
							{clientTypeToggle}
						</Form.Group>}
						{type === 'team' &&
						teamEditor}
						<Form.Group>
							<Button id = {'submitClient'}
								ref = {submitRef}
								onClick = {onSubmit}>
								{tempClient.id ? 'Übernehmen' : 'Anlegen'}
							</Button>
							<Button
								ref = {cancelRef}
								onClick = {onCancel}>
								{'Abbrechen'}
							</Button>
						</Form.Group>
					</Form>
				</Col>
			</Row>
		</>
	);
};

export default ClientCreator;
